<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12">
        <p class="text-h6 text-weight-bolder text-brand-1 texto-titulo">
          Consulta Ficha de EPI
        </p>
      </div>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-sm"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="exportar" icon="download" label="Exportar Ficha de EPI" />
      <q-tab
        name="acompanhamento"
        icon="monitor_heart"
        label="Acompanhamento"
      />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="exportar" class="q-pa-none q-pt-md">
        <div class="q-mb-lg">
          <p
            class="text-h6 text-weight-bold text-brand-1 q-mb-xs"
            style="margin: 0"
          >
            Exportar Fichas de EPI
          </p>
          <span class="text-caption text-grey-8"
            >Selecione colaboradores e configure as opções de exportação</span
          >
        </div>

        <div class="filtros-card q-mb-sm">
          <div class="row items-center justify-between q-mb-sm">
            <div class="row items-center q-gutter-sm">
              <q-icon name="filter_alt" size="20px" color="brand-1" />
              <span
                class="text-brand-1 text-weight-bold"
                style="font-size: 15px"
                >Filtros</span
              >
            </div>
          </div>
          <div class="row q-col-gutter-md items-end">
            <div class="ol-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="q-ml-sm texto-titulo-input">Unidade</div>
              <lista-unidades-select
                class="input-new-design"
                v-model="unidade.nome"
              />
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="q-ml-sm texto-titulo-input">Data Inicial</div>
              <q-input
                dense
                outlined
                class="input input-new-design"
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataInicial"
                mask="##/##/####"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataInicial"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="q-ml-sm texto-titulo-input">Data Final</div>
              <q-input
                dense
                outlined
                class="input input-new-design"
                placeholder="DD/MM/AAAA"
                v-model="filtros.dataFinal"
                mask="##/##/####"
              >
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy
                      cover
                      transition-show="scale"
                      transition-hide="scale"
                    >
                      <q-date
                        :locale="myLocale"
                        mask="DD/MM/YYYY"
                        v-model="filtros.dataFinal"
                      >
                        <div class="row items-center justify-end">
                          <q-btn
                            v-close-popup
                            label="Fechar"
                            color="primary"
                            flat
                          />
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
          </div>

          <div
            class="row row q-col-gutter-md items-endq-gutter-sm text-brand-5 text-weight-bold q-mt-sm container-inputs "
          >
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="q-ml-sm texto-titulo-input">Centro de Custo</div>
              <q-select
                class="input-new-design"
                dense
                outlined
                v-model="centroCustoSelecionado"
                :options="listaCentrosCustoOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                use-input
                clearable
                hide-selected
                fill-input
                input-debounce="0"
                :disable="!!funcaoSelecionada"
                @filter="filterCentroCustoFn"
              />
            </div>
            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
              <div class="q-ml-sm texto-titulo-input">Função</div>
              <q-select
                class="input-new-design"
                dense
                outlined
                v-model="funcaoSelecionada"
                :options="listaFuncoesOptions"
                option-label="name"
                option-value="id"
                emit-value
                map-options
                use-input
                clearable
                hide-selected
                fill-input
                input-debounce="0"
                :disable="!!centroCustoSelecionado"
                @filter="filterFuncaoFn"
              />
            </div>
            <div class="flex items-end">
              <q-btn
                label="Aplicar Filtros"
                color="brand-1"
                no-caps
                icon="filter_alt"
                style="border-radius: 8px; height: 40px; width: 100%"
                :loading="loadingLista"
                @click="aplicarFiltros"
              />
            </div>
          </div>
        </div>
        <div>
          <q-separator class="q-my-xl" />
        </div>
        <div class="exportar-linha2">
          <div class="exportar-col-main">
            <div v-if="filtrosAplicados" class="colaboradores-card">
              <div class="row q-mb-sm items-center justify-between">
                <p
                  style="font-size: 15px; margin: 0"
                  class="text-brand-1 texto-titulo"
                >
                  Colaboradores
                  <span class="text-caption text-grey-6 q-ml-sm">
                    {{ totalColaboradores }} encontrados ·
                    {{ colaboradoresSelecionados.length }} selecionado(s)
                  </span>
            
                </p>
           
                <q-btn
                  flat
                  no-caps
                  :label="
                    todaListaSelecionada
                      ? 'Desmarcar todos'
                      : 'Selecionar todos da página'
                  "
                  color="brand-1"
                  @click="selecionarTodosDaPagina"
                />               
              </div>                  
              <div class="q-mb-xs">
                <q-input
                  dense
                  outlined
                  class="input-new-design"
                  v-model="busca"
                  placeholder="Buscar por nome ou matrícula..."
                  clearable
                  @update:model-value="onBuscaChange"
                >
                  <template v-slot:prepend><q-icon name="search" /></template>
                </q-input>
              </div>

              <div class="lista-colaboradores-card">
                <div v-if="loadingLista" class="row justify-center q-pa-xl">
                  <q-spinner color="brand-1" size="40px" />
                </div>
                <div
                  v-else-if="listaColaboradores.length === 0"
                  class="row justify-center q-pa-xl text-grey-6"
                >
                  Nenhum colaborador encontrado.
                </div>
                <template v-else>
                  <div
                    v-for="(colaborador, index) in listaColaboradores"
                    :key="colaborador.id"
                  >
                    <div
                      class="row items-center q-px-md q-py-sm colaborador-item"
                      :class="{
                        'colaborador-selecionado':
                          colaboradoresSelecionados.includes(colaborador.id),
                      }"
                    >
                      <q-checkbox
                        v-model="colaboradoresSelecionados"
                        :val="colaborador.id"
                        color="brand-1"
                        class="q-mr-md"
                      />
                      <div class="col">
                        <div class="row items-center q-gutter-xs">
                          <span
                            class="text-weight-bold text-brand-5"
                            style="font-size: 14px"
                            >{{ colaborador.name }}</span
                          >
                          <span class="badge-matricula">{{
                            colaborador.sap
                          }}</span>
                        </div>
                        <div
                          class="row items-center q-gutter-xs q-mt-xs text-grey-6"
                          style="font-size: 12px"
                        >
                          <q-icon name="engineering" size="14px" />
                          <span
                            >{{ colaborador.function_model?.code }} -
                            {{ colaborador.function_model?.name }}</span
                          >
                          <span class="q-mx-xs">•</span>
                          <q-icon name="apartment" size="14px" />
                          <span>{{
                            colaborador?.cost_center?.name || "—"
                          }}</span>
                          <span class="q-mx-xs">•</span>
                          <q-icon name="calendar_today" size="14px" />
                          <span
                            >Desde
                            {{
                              colaborador.admission_date
                                ? colaborador.admission_date
                                    .split(" ")[0]
                                    .split("-")
                                    .reverse()
                                    .join("/")
                                : "—"
                            }}</span
                          >
                        </div>
                      </div>
                      <q-btn
                        flat
                        round
                        color="brand-1"
                        icon="folder_open"
                        size="md"
                        class="q-ml-sm btn-arquivos-ficha"
                        @click.stop="abrirModalArquivos(colaborador)"
                      >
                        <q-tooltip
                          anchor="top middle"
                          self="bottom middle"
                          :offset="[0, 6]"
                        >
                          Arquivos da Ficha{{
                            arquivosColaborador[colaborador.id]?.length
                              ? ` (${
                                  arquivosColaborador[colaborador.id].length
                                })`
                              : ""
                          }}
                        </q-tooltip>
                      </q-btn>
                    </div>
                    <q-separator v-if="index < listaColaboradores.length - 1" />
                  </div>
                  <div
                    class="row justify-between items-center q-px-md q-py-sm bg-grey-1"
                  >
                    <span class="text-caption text-grey-7"
                      >Página {{ paginaAtual }} de {{ totalPaginas }}</span
                    >
                    <q-pagination
                      v-model="paginaAtual"
                      :max="totalPaginas"
                      :max-pages="6"
                      boundary-numbers
                      color="brand-1"
                      active-color="brand-1"
                      direction-links
                      @update:model-value="trocarPagina"
                    />
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="exportar-col-side">
            <div class="acoes-card">
              <div class="row items-center q-gutter-sm q-mb-md">
                <q-icon name="settings" size="20px" color="brand-1" />
                <span
                  class="text-brand-1 text-weight-bold"
                  style="font-size: 15px"
                  >Ações</span
                >
              </div>

              <div class="text-caption text-grey-6 q-mb-xs">
                Todos os colaboradores
              </div>
              <q-btn
                color="white"
                label="Baixar todos os usuários"
                class="bg-brand-1 q-mb-sm"
                style="border-radius: 8px; width: 100%"
                no-caps
                icon="download"
                @click="baixarUsuarios(false)"
              />

              <q-separator class="q-my-md" />

              <div class="text-caption text-grey-6 q-mb-xs">
                Selecionados
                <span
                  v-if="colaboradoresSelecionados.length > 0"
                  class="badge-matricula q-ml-xs"
                  >{{ colaboradoresSelecionados.length }}</span
                >
              </div>

              <q-btn
                color="white"
                label="Baixar selecionados"
                class="bg-brand-2 q-mb-sm"
                style="border-radius: 8px; width: 100%"
                no-caps
                icon="download"
                :disable="colaboradoresSelecionados.length === 0"
                @click="baixarUsuarios(true)"
              />
              <q-btn
                color="white"
                label="Visualizar"
                class="bg-brand-1 q-mb-sm"
                no-caps
                style="border-radius: 8px; width: 100%"
                icon="visibility"
                :disable="
                  colaboradoresSelecionados.length === 0 || loadingVisualizar
                "
                :loading="loadingVisualizar"
                @click="abrirVisualizar"
              />

              <router-link
                v-if="colaboradoresSelecionados.length > 0"
                :to="{
                  name: 'seguranca-impressao-fichadeepi',
                  params: {
                    unidadeId: unidade.id,
                    solicitanteId: primeiroSelecionado?.id,
                    solicitanteSap: primeiroSelecionado?.sap,
                    solicitanteName:
                      primeiroSelecionado?.name ||
                      primeiroSelecionado?.sap ||
                      '',
                    dataInicial: filtros.dataInicial,
                    dataFinal: filtros.dataFinal,
                  },
                }"
                target="_blank"
                style="text-decoration: none"
              >
                <q-btn
                  label="Imprimir"
                  color="white"
                  class="bg-brand-2"
                  style="border-radius: 8px; width: 100%"
                  no-caps
                  icon="print"
                />
              </router-link>
              <q-btn
                v-else
                label="Imprimir"
                class="bg-brand-2"
                no-caps
                style="border-radius: 8px; width: 100%"
                color="white"
                icon="print"
                disable
              />
            </div>
          </div>
        </div>
      </q-tab-panel>

      <q-tab-panel name="acompanhamento" class="q-pa-none q-pt-md">
        <div class="row items-center justify-between q-mb-lg">
          <div>
            <p
              class="text-h6 text-weight-bold text-brand-1 q-mb-xs"
              style="margin: 0"
            >
              Acompanhamento de Exportação
            </p>
            <span class="text-caption text-grey-8"
              >Monitore o status das suas exportações em tempo real</span
            >
          </div>
          <q-btn
            flat
            no-caps
            icon="refresh"
            label="Atualizar"
            color="brand-1"
            style="border-radius: 8px; border: 1px solid #e0e0e0"
            :loading="acompLoadingHighlights"
            @click="carregarAcompanhamento(true)"
          />
        </div>

        <!-- highlights -->
        <div class="row q-gutter-sm q-mb-lg">
          <div class="acomp-highlight-card col acomp-highlight-total">
            <div class="acomp-highlight-label">Total</div>
            <div class="acomp-highlight-value text-black-8">
              {{ acompHighlights.total }}
            </div>
            <q-icon
              name="description"
              size="28px"
              class="acomp-highlight-icon text-grey-5"
            />
          </div>
          <div class="acomp-highlight-card col acomp-highlight-pending">
            <div class="acomp-highlight-label">Pendente</div>
            <div class="acomp-highlight-value text-grey-8">
              {{ acompHighlights.pending }}
            </div>
            <q-icon
              name="schedule"
              size="28px"
              class="acomp-highlight-icon text-grey-8"
            />
          </div>
          <div class="acomp-highlight-card col acomp-highlight-processing">
            <div class="acomp-highlight-label">Processando</div>
            <div class="acomp-highlight-value text-blue-8">
              {{ acompHighlights.processing }}
            </div>
            <q-icon
              name="sync"
              size="28px"
              class="acomp-highlight-icon text-blue-4"
            />
          </div>
          <div class="acomp-highlight-card col acomp-highlight-completed">
            <div class="acomp-highlight-label">Concluído</div>
            <div class="acomp-highlight-value text-green-8">
              {{ acompHighlights.completed }}
            </div>
            <q-icon
              name="check_circle"
              size="28px"
              class="acomp-highlight-icon text-green-4"
            />
          </div>
          <div class="acomp-highlight-card col acomp-highlight-error">
            <div class="acomp-highlight-label">Erro</div>
            <div class="acomp-highlight-value text-red-8">
              {{ acompHighlights.errors }}
            </div>
            <q-icon
              name="cancel"
              size="28px"
              class="acomp-highlight-icon text-red-4"
            />
          </div>
        </div>

        <div class="row q-gutter-sm q-mb-md items-end">
          <div class="col-md-4 col-sm-6 col-xs-12">
            <q-input
              dense
              outlined
              class="input-new-design"
              v-model="acompBusca"
              placeholder="Buscar por ID da Task..."
              clearable
              @update:model-value="onAcompBuscaChange"
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
          <div class="col-auto">
            <q-select
              dense
              outlined
              class="input-new-design"
              style="min-width: 180px"
              v-model="acompFiltroStatus"
              :options="acompStatusOptions"
              option-label="label"
              option-value="value"
              emit-value
              map-options
              @update:model-value="carregarAcompanhamento"
            />
          </div>
        </div>

        <div v-if="acompLoading" class="row justify-center q-pa-xl">
          <q-spinner color="brand-1" size="40px" />
        </div>

        <div
          v-else-if="acompTarefas.length === 0"
          class="row justify-center q-pa-xl text-grey-6"
        >
          Nenhuma exportação encontrada.
        </div>

        <div v-else class="column q-gutter-md">
          <div
            v-for="tarefa in acompTarefasFiltradas"
            :key="tarefa.taskId"
            class="acomp-task-card"
          >
            <div class="row items-center justify-between q-mb-sm">
              <div class="row items-center q-gutter-sm">
                <q-icon
                  :name="acompStatusIcon(tarefa.status)"
                  :color="acompStatusColor(tarefa.status)"
                  size="22px"
                />
                <span
                  class="text-weight-bold text-brand-1"
                  style="font-size: 15px"
                >
                  Task-{{ String(tarefa.taskId).padStart(3, "0") }}
                </span>
                <q-badge
                  :color="acompStatusBgColor(tarefa.status)"
                  :text-color="acompStatusTextColor(tarefa.status)"
                  class="acomp-status-badge"
                >
                  <q-icon
                    :name="acompStatusIcon(tarefa.status)"
                    size="11px"
                    class="q-mr-xs"
                  />
                  {{ acompStatusLabel(tarefa.status) }}
                </q-badge>
              </div>
              <q-btn flat round dense icon="more_vert" size="sm" color="grey-6">
                <q-menu>
                  <q-list dense style="min-width: 160px">
                    <q-item
                      clickable
                      v-close-popup
                      v-if="
                        tarefa.status === 'completed' && tarefa.metadata?.url
                      "
                      @click="downloadTarefa(tarefa)"
                    >
                      <q-item-section avatar
                        ><q-icon name="download"
                      /></q-item-section>
                      <q-item-section>Download</q-item-section>
                    </q-item>
                    <q-item
                      clickable
                      v-close-popup
                      @click="verDetalhesTarefa(tarefa)"
                    >
                      <q-item-section avatar
                        ><q-icon name="info"
                      /></q-item-section>
                      <q-item-section>Ver detalhes</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </div>

            <div
              class="row items-center q-gutter-xs text-grey-6 q-mb-sm"
              style="font-size: 12px"
            >
              <q-icon name="schedule" size="14px" />
              <span>{{ formatarDataHora(tarefa.createdAt) }}</span>
              <span class="q-mx-xs">•</span>
              <q-icon name="person" size="14px" />
              <span>{{ tarefa.userId }}</span>
              <span class="q-mx-xs">•</span>
              <q-icon name="group" size="14px" />
              <span>{{ tarefa.progress?.totalUsuarios ?? 0 }} Total</span>
              <span class="q-mx-xs">•</span>
              <q-icon name="check" size="14px" color="green-7" />
              <span class="text-green-8"
                >{{ tarefa.progress?.usuariosComRetiradas ?? 0 }} Com
                retiradas</span
              >
              <span class="q-mx-xs">•</span>
              <q-icon name="cancel" size="14px" color="orange-7" />
              <span class="text-orange-8"
                >{{ tarefa.progress?.usuariosSemRetiradas ?? 0 }} Sem
                retiradas</span
              >
            </div>

            <div class="row items-center q-gutter-xs q-mb-sm">
              <span class="text-grey-6" style="font-size: 12px">Formatos:</span>
              <q-badge
                v-if="
                  tarefa.metadata?.pdfsGeradosComSucesso > 0 ||
                  tarefa.status !== 'error'
                "
                color="grey-3"
                text-color="grey-8"
                class="acomp-format-badge"
                >PDF</q-badge
              >
            </div>

            <div
              v-if="
                tarefa.status === 'completed' &&
                tarefa.metadata?.url &&
                (tarefa.progress?.usuariosComRetiradas ?? 0) > 0
              "
              class="acomp-body-completed row items-center justify-between"
            >
              <div class="row items-center q-gutter-sm">
                <q-icon name="check_circle" color="green-7" size="18px" />
                <div>
                  <div
                    class="text-weight-bold text-green-8"
                    style="font-size: 13px"
                  >
                    Arquivo pronto para download
                  </div>
                  <div class="text-caption text-grey-6">
                    {{ tarefa.progress?.usuariosComRetiradas ?? 0 }} usuários
                    processados
                  </div>
                </div>
              </div>
              <q-btn
                color="green-7"
                no-caps
                icon="download"
                label="Download"
                style="border-radius: 8px"
                @click="downloadTarefa(tarefa)"
              />
            </div>

            <div
              v-else-if="
                tarefa.status === 'completed' &&
                (tarefa.progress?.usuariosComRetiradas ?? 0) === 0
              "
              class="acomp-body-warning row items-center q-gutter-sm"
            >
              <q-icon name="info" color="orange-7" size="18px" />
              <div>
                <div
                  class="text-weight-bold text-orange-8"
                  style="font-size: 13px"
                >
                  Nenhum usuário com retiradas encontrado
                </div>
                <div class="text-caption text-grey-6">
                  Não há arquivo disponível para download pois nenhum usuário
                  possui retiradas no período.
                </div>
              </div>
            </div>

            <div v-else-if="tarefa.status === 'error'" class="acomp-body-error">
              <div class="row items-center q-gutter-sm q-mb-xs">
                <q-icon name="error" color="red-7" size="18px" />
                <span
                  class="text-weight-bold text-red-8"
                  style="font-size: 13px"
                  >Erro ao processar exportação</span
                >
              </div>
              <div class="text-caption text-red-6 q-mb-sm">
                {{
                  tarefa.metadata?.erros?.[0]?.mensagem ||
                  tarefa.metadata?.failureReason ||
                  "Erro desconhecido"
                }}
              </div>
            </div>

            <div
              v-else-if="tarefa.status === 'processing'"
              class="acomp-body-processing row items-center q-gutter-sm"
            >
              <q-icon
                name="sync"
                color="blue-7"
                size="18px"
                class="spin-icon"
              />
              <div>
                <div
                  class="text-weight-bold text-blue-8"
                  style="font-size: 13px"
                >
                  Processando exportação...
                </div>
                <q-linear-progress
                  v-if="tarefa.progress?.totalUsuarios > 0"
                  :value="
                    tarefa.progress.pdfsProcessados /
                    tarefa.progress.totalUsuarios
                  "
                  color="blue-7"
                  class="q-mt-xs"
                  style="border-radius: 4px; height: 6px"
                />
              </div>
            </div>

            <div
              v-else-if="tarefa.status === 'pending'"
              class="acomp-body-pending row items-center q-gutter-sm"
            >
              <q-icon name="schedule" color="orange-7" size="18px" />
              <span
                class="text-weight-bold text-orange-8"
                style="font-size: 13px"
              >
                Aguardando processamento... Você será notificado quando estiver
                pronto.
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="!acompLoading && !acompBusca && acompTotalPaginas > 1"
          class="row justify-between items-center q-px-sm q-py-sm q-mt-sm bg-grey-1"
          style="border-radius: 8px"
        >
          <span class="text-caption text-grey-7">
            Página {{ acompPaginaAtual }} de {{ acompTotalPaginas }} ·
            {{ acompTotal }} exportações
          </span>
          <q-pagination
            v-model="acompPaginaAtual"
            :max="acompTotalPaginas"
            :max-pages="6"
            boundary-numbers
            color="brand-1"
            active-color="brand-1"
            direction-links
            @update:model-value="carregarAcompanhamento"
          />
        </div>
      </q-tab-panel>
    </q-tab-panels>

    <teleport to="body">
      <div
        v-if="loadingVisualizar"
        style="
          position: fixed;
          inset: 0;
          z-index: 9999;
          background: rgba(0, 0, 0, 0.45);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 16px;
        "
      >
        <q-spinner color="white" size="56px" />
        <span
          style="
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 0.3px;
          "
        >
          Carregando ficha...
        </span>
      </div>
    </teleport>

    <q-dialog
      v-model="visualizar"
      transition-show="rotate"
      transition-hide="rotate"
    >
      <q-card style="max-width: 95vw; min-width: 340px">
        <q-card-section class="row items-center q-pb-none">
          <span class="text-h6 text-brand-1">Ficha de EPI</span>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="row col-12">
            <div style="width: 18%" class="column justify-around top q-mb-sm">
              <q-img
                v-if="dadosDescricao?.url_logo"
                :src="dadosDescricao.url_logo"
              />
              <q-img v-else src="../../../assets/MULTPEX_VETOR.png" />
            </div>
          </div>

          <q-table
            :columns="columnsUsuario"
            :rows="dadosUsuarioVisualizar"
            dense
            color="primary"
            table-header-class="bg-white text-black text-weight-bold"
            hide-bottom
          >
            <template v-slot:body-cell-nomeUsuario="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.name
              }}</q-td>
            </template>
            <template v-slot:body-cell-SolicitanteSap="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.sap
              }}</q-td>
            </template>
            <template v-slot:body-cell-dataAdmissao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  props.row.admission_date
                    ?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-cargo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.cargo
              }}</q-td>
            </template>
            <template v-slot:body-cell-ghe="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row?.function_model?.name
              }}</q-td>
            </template>
          </q-table>

          <q-table
            class="q-mt-md"
            :columns="columnsFicha"
            :rows="dadosFichaEpiVisualizar"
            color="primary"
            table-header-class="bg-white text-black text-weight-bold"
            flat
            dense
            hide-bottom
            :rows-per-page-options="[0]"
          >
            <template v-slot:body-cell-planta="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.EntregaUnidadeNome
              }}</q-td>
            </template>
            <template v-slot:body-cell-funcaoGhe="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.SolicitanteFuncao
              }}</q-td>
            </template>
            <template v-slot:body-cell-centroCusto="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.CentroCustoNome
              }}</q-td>
            </template>
            <template v-slot:body-cell-RequisicaoNumero="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">{{
                props.row.RequisicaoNumero
              }}</q-td>
            </template>
            <template v-slot:body-cell-entregueEm="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  props.row.RetiradoPorData?.split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-ItemCodigo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  >{{ props.row.ItemCodigo?.slice(0, 20)
                  }}<q-tooltip>{{ props.row.ItemCodigo }}</q-tooltip></span
                >
              </q-td>
            </template>
            <template v-slot:body-cell-ItemNomeContrato="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  >{{ props.row?.ItemNomeContrato?.slice(0, 20)
                  }}<q-tooltip>{{
                    props.row.ItemNomeContrato
                  }}</q-tooltip></span
                >
              </q-td>
            </template>
            <template v-slot:body-cell-ItemCaCodigo="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  >{{ props.row?.ItemCaCodigo?.slice(0, 20)
                  }}<q-tooltip>{{ props.row.ItemCaCodigo }}</q-tooltip></span
                >
              </q-td>
            </template>
            <template v-slot:body-cell-quantidade="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                {{
                  Number(props.row.ItemQuantidade?.replace(",", ".")).toFixed(0)
                }}
              </q-td>
            </template>
            <template v-slot:body-cell-autenticacaoCriacao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  v-if="
                    props.row.AprovacaoAutenticacaoTipo != 'biometria' &&
                    props.row.AprovacaoAutenticacaoTipo != 'assinatura' &&
                    props.row.AprovacaoAutenticacaoTipo != 'facial'
                  "
                >
                  Assinado eletronicamente
                </span>
                <span v-else>
                  <q-img
                    :src="props.row.AprovacaoAutenticacao"
                    style="max-width: 300px; height: 70px"
                    fit="contain"
                  />
                </span>
              </q-td>
            </template>
            <template v-slot:body-cell-autenticacaoFinalizacao="props">
              <q-td class="text-brand-5 text-weight-bold" :props="props">
                <span
                  v-if="
                    props.row.FinalizacaoAutenticacaoTipo != 'biometria' &&
                    props.row.FinalizacaoAutenticacaoTipo != 'assinatura' &&
                    props.row.FinalizacaoAutenticacaoTipo != 'facial'
                  "
                >
                  Assinado eletronicamente
                </span>
                <span v-else>
                  <q-img
                    :src="props.row.FinalizacaoAutenticacao"
                    style="max-width: 300px; height: 70px"
                    fit="contain"
                  />
                </span>
              </q-td>
            </template>
          </q-table>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat no-caps label="Fechar" color="brand-1" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog
      v-model="acompDetalheAberto"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card style="min-width: 520px; max-width: 680px; width: 100%">
        <q-card-section class="row items-center q-pb-none">
          <span class="text-h6 text-brand-1">Detalhes da Exportação</span>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section v-if="acompTarefaDetalhe">
          <div class="row q-gutter-sm q-mb-md">
            <q-badge
              :color="acompStatusBgColor(acompTarefaDetalhe.status)"
              :text-color="acompStatusTextColor(acompTarefaDetalhe.status)"
              class="acomp-status-badge"
            >
              <q-icon
                :name="acompStatusIcon(acompTarefaDetalhe.status)"
                size="12px"
                class="q-mr-xs"
              />
              {{ acompStatusLabel(acompTarefaDetalhe.status) }}
            </q-badge>
          </div>

          <q-list dense separator>
            <q-item>
              <q-item-section>
                <q-item-label caption>Task ID</q-item-label>
                <q-item-label>{{ acompTarefaDetalhe.taskId }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label caption>Criado em</q-item-label>
                <q-item-label>{{
                  formatarDataHora(acompTarefaDetalhe.createdAt)
                }}</q-item-label>
              </q-item-section>
              <q-item-section>
                <q-item-label caption>Finalizado em</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.finishedAt
                    ? formatarDataHora(acompTarefaDetalhe.finishedAt)
                    : "—"
                }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label caption>Total de usuários</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.progress?.totalUsuarios ?? "—"
                }}</q-item-label>
              </q-item-section>
              <q-item-section>
                <q-item-label caption>Com retiradas</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.progress?.usuariosComRetiradas ?? "—"
                }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label caption>PDFs gerados</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.metadata?.pdfsGeradosComSucesso ?? "—"
                }}</q-item-label>
              </q-item-section>
              <q-item-section>
                <q-item-label caption>PDFs com falha</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.metadata?.pdfsComFalha ?? "—"
                }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item>
              <q-item-section>
                <q-item-label caption>Tipo de grupo</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.metadata?.grupoTipo ?? "—"
                }}</q-item-label>
              </q-item-section>
              <q-item-section>
                <q-item-label caption>ID do grupo</q-item-label>
                <q-item-label>{{
                  acompTarefaDetalhe.metadata?.grupoId ?? "—"
                }}</q-item-label>
              </q-item-section>
            </q-item>
            <q-item v-if="acompTarefaDetalhe.metadata?.erros?.length">
              <q-item-section>
                <q-item-label caption class="text-red-7">Erros</q-item-label>
                <q-item-label
                  v-for="(err, i) in acompTarefaDetalhe.metadata.erros"
                  :key="i"
                  class="text-red-8"
                >
                  [{{ err.fase }}] {{ err.mensagem }}
                </q-item-label>
              </q-item-section>
            </q-item>
            <q-item v-if="acompTarefaDetalhe.metadata?.failureReason">
              <q-item-section>
                <q-item-label caption class="text-red-7"
                  >Motivo da falha</q-item-label
                >
                <q-item-label class="text-red-8">{{
                  acompTarefaDetalhe.metadata.failureReason
                }}</q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            v-if="
              acompTarefaDetalhe?.status === 'completed' &&
              acompTarefaDetalhe?.metadata?.url
            "
            color="green-7"
            no-caps
            icon="download"
            label="Download"
            style="border-radius: 8px"
            @click="downloadTarefa(acompTarefaDetalhe)"
            v-close-popup
          />
          <q-btn flat no-caps label="Fechar" color="brand-1" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- modal arquivos da ficha -->
    <q-dialog
      v-model="modalArquivosAberto"
      transition-show="scale"
      transition-hide="scale"
    >
      <q-card
        style="
          min-width: 480px;
          max-width: 560px;
          width: 100%;
          border-radius: 16px;
        "
      >
        <q-card-section class="row items-center q-pb-none">
          <div class="row items-center q-gutter-sm">
            <q-icon name="folder_open" color="brand-1" size="22px" />
            <span class="text-h6 text-brand-1">Arquivos da Ficha</span>
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section v-if="colaboradorArquivosAtivo" class="q-pb-xs">
          <div class="row items-center q-gutter-xs q-mb-sm">
            <span class="text-weight-bold text-brand-5" style="font-size: 13px">
              {{ colaboradorArquivosAtivo.name }}
            </span>
            <span class="badge-matricula">{{
              colaboradorArquivosAtivo.sap
            }}</span>
          </div>
        </q-card-section>

        <q-card-section class="q-pt-xs">
          <div v-if="loadingArquivos" class="row justify-center q-pa-lg">
            <q-spinner color="brand-1" size="36px" />
          </div>

          <div
            v-else-if="arquivosModalAtivos.length === 0"
            class="row justify-center items-center q-pa-lg text-grey-6 column"
          >
            <q-icon name="folder_off" size="40px" class="q-mb-sm" />
            <span>Nenhum arquivo encontrado.</span>
          </div>

          <div v-else>
            <q-carousel
              animated
              v-model="slideModal"
              arrows
              height="220px"
              control-type="regular"
              control-color="brand-1"
              infinite
              style="
                border-radius: 12px;
                border: 1px solid #e0e0e0;
                background: #f8f9fb;
              "
            >
              <q-carousel-slide
                v-for="(arquivo, idx) in arquivosModalAtivos"
                :key="idx"
                :name="idx"
                :img-src="getIconeArquivo(arquivo.url)"
                style="background-size: contain; background-repeat: no-repeat"
              >
                <div class="absolute-bottom custom-caption-modal">
                  <div class="text-h5">
                    {{ arquivo.descricao_ficha || "Sem descrição" }}
                  </div>
                  <div v-if="arquivo.created_at" class="text-subtitle1">
                    {{
                      arquivo.created_at
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/") +
                      " " +
                      arquivo.created_at.split(" ")[1]
                    }}
                  </div>
                </div>
              </q-carousel-slide>

              <template v-slot:control>
                <q-carousel-control position="bottom-right" :offset="[10, 20]">
                  <q-btn
                    push
                    round
                    dense
                    color="white"
                    text-color="brand-1"
                    icon="download"
                    size="md"
                    @click="baixarArquivoModal(slideModal)"
                  >
                    <q-tooltip>Download</q-tooltip>
                  </q-btn>
                </q-carousel-control>

                <q-carousel-control position="bottom-left" :offset="[10, 20]">
                  <q-btn
                    push
                    round
                    dense
                    color="red"
                    icon="delete"
                    size="md"
                    @click="confirmarExclusaoArquivo(slideModal)"
                  >
                    <q-tooltip>Excluir arquivo</q-tooltip>
                  </q-btn>
                </q-carousel-control>
              </template>
            </q-carousel>

            <div class="row justify-center q-mt-sm">
              <span class="text-caption text-grey-6">
                {{ slideModal + 1 }} de {{ arquivosModalAtivos.length }}
              </span>
            </div>
          </div>

          <div class="q-mt-md">
            <label for="arquivo-modal" style="cursor: pointer; width: 100%">
              <q-btn
                icon="upload"
                label="Fazer upload de arquivo"
                no-caps
                color="brand-2"
                style="border-radius: 8px; width: 100%; pointer-events: none"
                :loading="loadingUpload"
              />
            </label>
            <input
              id="arquivo-modal"
              type="file"
              @change="onFileSelectedModal"
              style="display: none"
            />
          </div>
        </q-card-section>

        <q-card-actions align="right" class="q-pt-none q-pb-md q-pr-md">
          <q-btn flat no-caps label="Fechar" color="brand-1" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="confirmUploadModal" persistent>
      <q-card
        class="q-pa-sm text-brand-5 text-weight-bolder"
        style="min-width: 360px"
      >
        <q-card-section class="row items-center">
          <q-icon
            name="upload_file"
            color="brand-1"
            size="24px"
            class="q-mr-sm"
          />
          <span>Adicionar arquivo à ficha?</span>
        </q-card-section>
        <q-card-section>
          <q-input
            dense
            outlined
            label="Descrição (opcional)"
            v-model="descricaoUploadModal"
          />
        </q-card-section>
        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Cancelar"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Confirmar"
            color="positive"
            icon="check_circle_outline"
            v-close-popup
            @click="adicionarArquivoModal"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const PER_PAGE = 15;

const columnsUsuario = [
  { name: "nomeUsuario", label: "Nome Usuário", align: "left" },
  { name: "SolicitanteSap", label: "SAP Usuário", align: "left" },
  { name: "dataAdmissao", label: "Data Admissão", align: "left" },
  { name: "cargo", label: "Cargo", align: "left" },
  { name: "ghe", label: "GHE", align: "left" },
];

const columnsFicha = [
  {
    name: "planta",
    label: "Planta",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "funcaoGhe",
    label: "Função (GHE)",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "centroCusto",
    label: "Centro de Custo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "RequisicaoNumero",
    label: "Numero Requisição",
    align: "left",
    field: "RequisicaoNumero",
    style: "white-space: normal",
  },
  {
    name: "entregueEm",
    label: "Data de Entrega",
    field: "RetiradoPorData",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "ItemCodigo",
    label: "Codigo Produto",
    align: "left",
    style: "width: 90px",
    field: "ItemCodigo",
  },
  {
    name: "ItemNomeContrato",
    label: "Descrição Produto",
    align: "left",
    style: "white-space: normal",
    field: "ItemNomeContrato",
  },
  {
    name: "ItemCaCodigo",
    label: "CA",
    align: "left",
    style: "white-space: normal",
    field: "ItemCaCodigo",
  },
  {
    name: "quantidade",
    label: "Quantidade",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "autenticacaoCriacao",
    label: "Autenticação Criação",
    align: "right",
    style: "height: 70px; white-space: normal",
  },
  {
    name: "autenticacaoFinalizacao",
    label: "Autenticação Finalização.",
    align: "right",
    style: "height: 70px; white-space: normal",
  },
];

export default {
  name: "ExportFichaEpiNew",
  components: { ListaUnidadesSelect },

  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData?.id,
    });

    watch(
      () => store.state.org.unidadeData,
      (val) => {
        unidade.value.nome = val;
        unidade.value.id = val?.id;
      }
    );

    const filtros = ref({
      dataInicial: "01/01/2001",
      dataFinal: new Date()
        .toISOString()
        .substring(0, 10)
        .split("-")
        .reverse()
        .join("/"),
      centro: "",
      funcao: "",
    });

    const listaColaboradores = ref([]);
    const cacheTodosColaboradores = ref([]);
    const colaboradoresSelecionados = ref([]);
    const loadingLista = ref(false);
    const filtrosAplicados = ref(false);
    const visualizar = ref(false);

    const dadosUsuarioVisualizar = ref([]);
    const dadosFichaEpiVisualizar = ref([]);
    const dadosDescricao = ref(null);

    const paginaAtual = ref(1);
    const totalPaginas = ref(1);
    const totalColaboradores = ref(0);

    const busca = ref("");

    const todaListaSelecionada = computed(
      () =>
        listaColaboradores.value.length > 0 &&
        listaColaboradores.value.every((c) =>
          colaboradoresSelecionados.value.includes(c.id)
        )
    );

    const primeiroSelecionado = computed(() => {
      if (!colaboradoresSelecionados.value.length) return null;
      return cacheTodosColaboradores.value.find(
        (c) => c.id === colaboradoresSelecionados.value[0]
      );
    });

    const colaboradoresSelecionadosNomes = computed(() =>
      cacheTodosColaboradores.value
        .filter((c) => colaboradoresSelecionados.value.includes(c.id))
        .map((c) => c.name)
    );

    const centroCustoSelecionado = ref(null);
    const funcaoSelecionada = ref(null);
    const listaCentrosCustoOptions = ref([]);
    const listaFuncoesOptions = ref([]);
    const time = ref();

    const filterCentroCustoFn = async (val, update, abort) => {
      clearTimeout(time.value);
      if (val.length < 1) {
        abort();
        return;
      }
      time.value = setTimeout(async () => {
        const response = await store.dispatch("seguranca/listarCentrosCusto", {
          search: val,
        });
        listaCentrosCustoOptions.value = response.data.results.data;
        update();
      }, 2000);
    };

    const filterFuncaoFn = async (val, update, abort) => {
      clearTimeout(time.value);
      if (val.length < 1) {
        abort();
        return;
      }
      time.value = setTimeout(async () => {
        const response = await store.dispatch("seguranca/listarFuncoes", {
          search: val,
        });
        listaFuncoesOptions.value = response.data.results.data;
        update();
      }, 2000);
    };

    const buscarPagina = async (pagina) => {
      loadingLista.value = true;
      try {
        const response = await store.dispatch(
          "seguranca/listarUsuariosPorUnidade",
          {
            vendor_id: unidade.value.id,
            per_page: PER_PAGE,
            page: pagina,
            search: busca.value,
            cost_center_id: centroCustoSelecionado.value || undefined,
            function_id: funcaoSelecionada.value || undefined,
          }
        );

        const resultado = response.data.results ?? {};
        const dados = resultado.data ?? [];

        listaColaboradores.value = dados;
        totalPaginas.value = resultado.last_page ?? 1;
        totalColaboradores.value = resultado.total ?? dados.length;

        dados.forEach((c) => {
          if (!cacheTodosColaboradores.value.find((x) => x.id === c.id)) {
            cacheTodosColaboradores.value.push(c);
          }
        });

        // arquivos so carregados ao abrir o modal
      } catch (error) {
        console.error(error);
        quasar.notify({
          message: "Erro ao buscar colaboradores.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loadingLista.value = false;
      }
    };

    const buscaDebounceTimer = ref(null);

    const onBuscaChange = () => {
      clearTimeout(buscaDebounceTimer.value);
      buscaDebounceTimer.value = setTimeout(() => {
        paginaAtual.value = 1;
        buscarPagina(1);
      }, 400);
    };

    const aplicarFiltros = async () => {
      if (!unidade.value.id) {
        quasar.notify({
          message: "Selecione uma unidade para aplicar os filtros.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
        return;
      }
      paginaAtual.value = 1;
      colaboradoresSelecionados.value = [];
      cacheTodosColaboradores.value = [];
      filtrosAplicados.value = false;

      await buscarPagina(1);
      filtrosAplicados.value = true;
    };

    const trocarPagina = (pagina) => {
      buscarPagina(pagina);
    };

    const selecionarTodosDaPagina = () => {
      if (todaListaSelecionada.value) {
        const idsNaPagina = listaColaboradores.value.map((c) => c.id);
        colaboradoresSelecionados.value =
          colaboradoresSelecionados.value.filter(
            (id) => !idsNaPagina.includes(id)
          );
      } else {
        listaColaboradores.value.forEach((c) => {
          if (!colaboradoresSelecionados.value.includes(c.id)) {
            colaboradoresSelecionados.value.push(c.id);
          }
        });
      }
    };

    const toApiDate = (dataBR) => dataBR.split("/").reverse().join("-");

    const baixarUsuarios = async (apenassSelecionados = false) => {
      if (apenassSelecionados && colaboradoresSelecionados.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos um colaborador.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
        return;
      }

      try {
        const vendorId = unidade.value.id;
        const dataInicial = toApiDate(filtros.value.dataInicial);
        const dataFinal = toApiDate(filtros.value.dataFinal);
        let payload;

        if (centroCustoSelecionado.value) {
          payload = {
            group_type: "COST_CENTER",
            group_id: String(centroCustoSelecionado.value),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else if (funcaoSelecionada.value) {
          payload = {
            group_type: "FUNCTION",
            group_id: String(funcaoSelecionada.value),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else if (
          apenassSelecionados &&
          colaboradoresSelecionados.value.length > 0
        ) {
          const userIds = colaboradoresSelecionados.value.map((e) => String(e));
          payload = {
            group_type: "EMPLOYEE",
            group_id: userIds,
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        } else {
          payload = {
            group_type: "VENDOR",
            group_id: String(vendorId),
            data_inicial: dataInicial,
            data_final: dataFinal,
            vendor_id: vendorId,
          };
        }

        await store.dispatch("seguranca/baixarUsuarios", payload);

        quasar.notify({
          message: "Download solicitado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao fazer download",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      }
    };

    const abrirVisualizar = async () => {
      if (!colaboradoresSelecionados.value.length) return;

      const colaborador = cacheTodosColaboradores.value.find(
        (c) => c.id === colaboradoresSelecionados.value[0]
      );
      if (!colaborador) return;

      loadingVisualizar.value = true;

      try {
        dadosUsuarioVisualizar.value = [colaborador];

        const [fichaRes, descricaoRes] = await Promise.all([
          store.dispatch("seguranca/listarDadosFichaEpi", {
            dataFinal: filtros.value.dataFinal,
            dataInicial: filtros.value.dataInicial,
            epi: 1,
            per_page: 1000,
            solicitanteId: colaborador.id,
            solicitanteSap: colaborador.sap,
          }),
          store.dispatch("seguranca/getDescricao", {
            vendor_id: unidade.value.id,
          }),
        ]);

        dadosFichaEpiVisualizar.value = fichaRes.data.return?.data ?? [];
        dadosDescricao.value = descricaoRes.data.response;
        visualizar.value = true;
      } catch (e) {
        quasar.notify({
          message: "Erro ao carregar ficha.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loadingVisualizar.value = false;
      }
    };

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    onMounted(() => {
      const raw = localStorage.getItem("unidade");
      if (raw && raw !== "null") {
        const parsed = JSON.parse(raw);
        unidade.value.nome = parsed;
        unidade.value.id = parsed?.id;
      }

      if (unidade.value.id) {
        aplicarFiltros();
      }
    });

    // acompanhamento
    const tab = ref("exportar");

    const acompTarefas = ref([]);
    const acompHighlights = ref({
      total: 0,
      pending: 0,
      processing: 0,
      completed: 0,
      errors: 0,
    });
    const acompLoading = ref(false);
    const acompLoadingHighlights = ref(false);
    const acompBusca = ref("");
    const acompFiltroStatus = ref(null);
    const acompDetalheAberto = ref(false);
    const acompTarefaDetalhe = ref(null);
    const acompPaginaAtual = ref(1);
    const acompTotalPaginas = ref(1);
    const acompTotal = ref(0);

    const acompStatusOptions = [
      { label: "Todos os status", value: null },
      { label: "Pendente", value: "pending" },
      { label: "Processando", value: "processing" },
      { label: "Concluído", value: "completed" },
      { label: "Erro", value: "error" },
    ];

    const acompStatusLabel = (status) =>
      ({
        pending: "Pendente",
        processing: "Processando",
        completed: "Concluído",
        error: "Erro",
      }[status] ?? status);

    const acompStatusIcon = (status) =>
      ({
        pending: "schedule",
        processing: "sync",
        completed: "check_circle",
        error: "cancel",
      }[status] ?? "help");

    const acompStatusColor = (status) =>
      ({
        pending: "orange-7",
        processing: "blue-7",
        completed: "green-7",
        error: "red-7",
      }[status] ?? "grey");

    const acompStatusBgColor = (status) =>
      ({
        pending: "orange-1",
        processing: "blue-1",
        completed: "green-1",
        error: "red-1",
      }[status] ?? "grey-2");

    const acompStatusTextColor = (status) =>
      ({
        pending: "orange-9",
        processing: "blue-9",
        completed: "green-9",
        error: "red-9",
      }[status] ?? "grey-9");

    const formatarDataHora = (iso) => {
      if (!iso) return "—";
      const d = new Date(iso);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(
        d.getMonth() + 1
      )}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const carregarAcompanhamento = async (mostrarSucesso = false) => {
      acompLoading.value = true;
      acompLoadingHighlights.value = true;
      try {
        const userId = store.state.autenticacao.idBase;
        const response = await store.dispatch(
          "seguranca/getExportFichaEpiStatus",
          {
            userId,
            status: acompFiltroStatus.value || undefined,
            page: acompPaginaAtual.value,
            per_page: PER_PAGE,
          }
        );

        const data = response.data;
        const result = data.result ?? {};
        acompTarefas.value = result.data ?? [];
        const total = result.total ?? acompTarefas.value.length;
        const perPage = result.perPage ?? PER_PAGE;
        acompTotal.value = total;
        acompTotalPaginas.value = Math.ceil(total / perPage) || 1;
        const h = data.highlights ?? {};
        acompHighlights.value = { total, ...h };

        if (mostrarSucesso) {
          quasar.notify({
            message: "Atualizado com sucesso",
            color: "positive",
            actions: [{ label: "Fechar", color: "white" }],
          });
        }
      } catch (e) {
        quasar.notify({
          message: "Erro ao carregar acompanhamento.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        acompLoading.value = false;
        acompLoadingHighlights.value = false;
      }
    };

    const acompTarefasFiltradas = computed(() => {
      if (!acompBusca.value) return acompTarefas.value;
      const termo = acompBusca.value.toLowerCase();
      return acompTarefas.value.filter(
        (t) =>
          String(t.taskId).includes(termo) ||
          String(t.userId).toLowerCase().includes(termo)
      );
    });

    const onAcompBuscaChange = () => {
      acompPaginaAtual.value = 1;
    };

    const downloadTarefa = (tarefa) => {
      const url = tarefa.metadata?.url;
      if (!url) return;
      window.open(url, "_blank");
      quasar.notify({
        message: "Download iniciado com sucesso",
        color: "positive",
        actions: [{ label: "Fechar", color: "white" }],
      });
    };

    const verDetalhesTarefa = (tarefa) => {
      acompTarefaDetalhe.value = tarefa;
      acompDetalheAberto.value = true;
    };

    watch(
      () => tab.value,
      (val) => {
        if (val === "acompanhamento") carregarAcompanhamento();
      }
    );

    // arquivos da ficha
    const arquivosColaborador = ref({});
    const modalArquivosAberto = ref(false);
    const colaboradorArquivosAtivo = ref(null);
    const arquivosModalAtivos = ref([]);
    const slideModal = ref(0);
    const loadingArquivos = ref(false);
    const loadingUpload = ref(false);
    const confirmUploadModal = ref(false);
    const descricaoUploadModal = ref("");
    const fileModalBase64 = ref("");

    const getIconeArquivo = (url) => {
      if (!url) return require("../../../assets/imageDefoult.jpg");
      if (url.includes("pdf")) return require("../../../assets/pdfIcon.png");
      if (url.includes("xml")) return require("../../../assets/exelIcon.png");
      if (url.includes("png"))
        return require("../../../assets/extensao-png.png");
      if (url.includes("zip"))
        return require("../../../assets/extensao-zip.png");
      if (url.includes("jpeg") || url.includes("jpg"))
        return require("../../../assets/extensao-jpeg.png");
      return url;
    };

    const abrirModalArquivos = async (colaborador) => {
      colaboradorArquivosAtivo.value = colaborador;
      slideModal.value = 0;
      modalArquivosAberto.value = true;
      loadingArquivos.value = true;
      try {
        const res = await store.dispatch("seguranca/getArquivos", {
          user_id: colaborador.id,
        });
        const lista = res.data?.data?.data ?? [];
        arquivosModalAtivos.value = lista;
        arquivosColaborador.value = {
          ...arquivosColaborador.value,
          [colaborador.id]: lista,
        };
      } catch {
        quasar.notify({
          message: "Erro ao carregar arquivos.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loadingArquivos.value = false;
      }
    };

    const baixarArquivoModal = async (idx) => {
      try {
        const arquivo = arquivosModalAtivos.value[idx];
        const res = await store.dispatch("seguranca/baixarArquivo", {
          uuid: arquivo.uuid_arquivo,
        });
        window.open(res.data.data, "_blank");
      } catch {
        quasar.notify({
          message: "Erro ao baixar arquivo.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      }
    };

    const confirmarExclusaoArquivo = (idx) => {
      quasar
        .dialog({
          title: "Excluir arquivo",
          message: "Tem certeza que deseja excluir este arquivo?",
          cancel: { label: "Cancelar", flat: true, color: "brand-1" },
          ok: { label: "Excluir", color: "negative", unelevated: true },
          persistent: true,
        })
        .onOk(async () => {
          try {
            const arquivo = arquivosModalAtivos.value[idx];
            await store.dispatch("seguranca/deletarArquivo", {
              uuid: arquivo.uuid_arquivo,
            });
            quasar.notify({
              message: "Arquivo excluído com sucesso.",
              color: "positive",
              actions: [{ label: "Fechar", color: "white" }],
            });
            slideModal.value = 0;
          } catch {
            quasar.notify({
              message: "Erro ao excluir arquivo.",
              color: "negative",
              actions: [{ label: "Fechar", color: "white" }],
            });
          }
        });
    };

    const onFileSelectedModal = (e) => {
      const f = e.target.files[0];
      if (!f) return;
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.addEventListener("load", () => {
        fileModalBase64.value = reader.result;
        descricaoUploadModal.value = "";
        confirmUploadModal.value = true;
      });
      e.target.value = "";
    };

    const adicionarArquivoModal = async () => {
      if (!fileModalBase64.value || !colaboradorArquivosAtivo.value) return;
      loadingUpload.value = true;
      try {
        await store.dispatch("seguranca/subirArquivo", {
          imagem: fileModalBase64.value,
          user_id: colaboradorArquivosAtivo.value.id,
          descricao: descricaoUploadModal.value,
        });
        quasar.notify({
          message: "Arquivo enviado com sucesso.",
          color: "positive",
          actions: [{ label: "Fechar", color: "white" }],
        });

        const res = await store.dispatch("seguranca/getArquivos", {
          user_id: colaboradorArquivosAtivo.value.id,
        });
        const lista = res.data?.data?.data ?? [];
        arquivosModalAtivos.value = lista;
        arquivosColaborador.value = {
          ...arquivosColaborador.value,
          [colaboradorArquivosAtivo.value.id]: lista,
        };
        slideModal.value = lista.length - 1;
        fileModalBase64.value = "";
        descricaoUploadModal.value = "";
      } catch {
        quasar.notify({
          message: "Erro ao enviar arquivo.",
          color: "negative",
          actions: [{ label: "Fechar", color: "white" }],
        });
      } finally {
        loadingUpload.value = false;
      }
    };

    const loadingVisualizar = ref(false);

    return {
      unidade,
      filtros,
      myLocale,
      listaColaboradores,
      colaboradoresSelecionados,
      colaboradoresSelecionadosNomes,
      primeiroSelecionado,
      todaListaSelecionada,
      loadingLista,
      filtrosAplicados,
      visualizar,
      paginaAtual,
      totalPaginas,
      totalColaboradores,
      busca,
      centroCustoSelecionado,
      funcaoSelecionada,
      listaCentrosCustoOptions,
      listaFuncoesOptions,
      filterCentroCustoFn,
      filterFuncaoFn,
      aplicarFiltros,
      trocarPagina,
      selecionarTodosDaPagina,
      onBuscaChange,
      baixarUsuarios,
      columnsUsuario,
      columnsFicha,
      dadosUsuarioVisualizar,
      dadosFichaEpiVisualizar,
      dadosDescricao,

      abrirVisualizar,
      tab,

      // acompanhamento
      acompTarefas,
      acompTarefasFiltradas,
      acompHighlights,
      acompLoading,
      acompLoadingHighlights,
      acompBusca,
      acompFiltroStatus,
      acompStatusOptions,
      acompDetalheAberto,
      acompTarefaDetalhe,
      acompPaginaAtual,
      acompTotalPaginas,
      acompTotal,
      acompStatusLabel,
      acompStatusIcon,
      acompStatusColor,
      acompStatusBgColor,
      acompStatusTextColor,
      formatarDataHora,
      carregarAcompanhamento,
      onAcompBuscaChange,
      downloadTarefa,
      verDetalhesTarefa,

      // arquivos da ficha
      arquivosColaborador,
      modalArquivosAberto,
      colaboradorArquivosAtivo,
      arquivosModalAtivos,
      slideModal,
      loadingArquivos,
      loadingUpload,
      confirmUploadModal,
      descricaoUploadModal,
      getIconeArquivo,
      abrirModalArquivos,
      baixarArquivoModal,
      confirmarExclusaoArquivo,
      onFileSelectedModal,
      adicionarArquivoModal,

      loadingVisualizar,
    };
  },
};
</script>

<style>
.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>

<style scoped>
.secao-titulo {
  margin: 28px 0 -4px 0;
}

.texto-titulo-input {
  color: #21324a;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}

.lista-colaboradores-card {
  margin: 16px 0px;
  overflow: hidden;
  background: #fff;
}

.colaborador-item {
  transition: background 0.15s;
  margin: 8px;
}

.colaborador-item:hover {
  background: #f5f9ff;
}

.colaborador-selecionado {
  background: #eef5fd;
}

.badge-matricula {
  background: #e8f0fb;
  color: #2356a8;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 8px;
  border-radius: 20px;
}

a {
  text-decoration: none;
}

.acomp-highlight-card {
  position: relative;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px 20px;
  background: #fff;
  min-width: 110px;
}
.acomp-highlight-total {
  border-left: 4px solid #000000;
}
.acomp-highlight-pending {
  border-left: 4px solid #808080;
}
.acomp-highlight-processing {
  border-left: 4px solid #1976d2;
}
.acomp-highlight-completed {
  border-left: 4px solid #2e7d32;
}
.acomp-highlight-error {
  border-left: 4px solid #c62828;
}

.acomp-highlight-label {
  font-size: 12px;
  color: #7a7a7a;
  font-weight: 500;
  margin-bottom: 4px;
}
.acomp-highlight-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
}
.acomp-highlight-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.45;
}

.acomp-task-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 18px 20px;
}

.acomp-status-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
}

.acomp-format-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
}

.acomp-body-completed {
  background: #f0faf2;
  border: 1px solid #c8e6c9;
  border-radius: 8px;
  padding: 12px 16px;
}
.acomp-body-error {
  background: #fff5f5;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 12px 16px;
}
.acomp-body-processing {
  background: #f0f7ff;
  border: 1px solid #bbdefb;
  border-radius: 8px;
  padding: 12px 16px;
}
.acomp-body-pending {
  background: #fffde7;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 12px 16px;
}

.acomp-body-warning {
  background: #fff8e1;
  border: 1px solid #ffcc80;
  border-radius: 8px;
  padding: 12px 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.spin-icon {
  animation: spin 1.4s linear infinite;
  display: inline-block;
}
.filtros-card {

  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.acoes-card {

  padding: 16px 20px;
  width: 420px;
  min-width: 420px;
  flex-shrink: 0;
}

.acoes-card-spacer {
  width: 350px;
  min-width: 350px;
  flex-shrink: 0;
}

.colaboradores-card {

  border-radius: 12px;
  padding: 16px 20px;
}

.custom-caption-modal {
  text-align: center;
  padding: 8px 12px;
  color: white;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 0 0 12px 12px;
}

.btn-arquivos-ficha {
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  flex-shrink: 0;
  background: #eef4ff !important;
  transition: background 0.18s, border-color 0.18s, box-shadow 0.18s;
}

.btn-arquivos-ficha:hover {
  background: #d6e4ff !important;
  border-color: #2356a8 !important;
  box-shadow: 0 2px 8px rgba(35, 86, 168, 0.18);
}

.btn-arquivos-ficha .q-icon {
  font-size: 22px !important;
}

.exportar-col-main {
  flex: 1;
}

.exportar-col-side {
  width: 420px;
  min-width: 420px;
  flex-shrink: 0;
}

.exportar-linha2 {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}
</style>
